(function () {
  'use strict';
  // Desktop SOUND state control.

  var CAPTIONS = [
    {
      name: 'fire-pit',
      srcMatch: '67a513ea37b644f0beee5d3a150ca81a',
      minDuration: 44,
      maxDuration: 48,
      track: window.BisonProductVideoCaptions.firePit
    },
    {
      name: 'charcoal-grill',
      srcMatch: '0030f0b7328a4273873c0155faabe318',
      minDuration: 70,
      maxDuration: 75,
      track: window.BisonProductVideoCaptions.charcoalGrill
    },
    {
      name: 'fireplace',
      srcMatch: 'adad97b4dee3404caa9e141cdde02bc5',
      minDuration: 90,
      maxDuration: 95,
      track: window.BisonProductVideoCaptions.fireplace,
      poster: window.BisonProductVideoCaptions.fireplacePoster
    }
  ];

  function videoSource(video) {
    var source = video.currentSrc || video.getAttribute('src') || '';
    var child = video.querySelector('source[src]');
    return source || (child ? child.getAttribute('src') : '');
  }

  function captionFor(video) {
    var src = videoSource(video);
    var duration = Number(video.duration);
    return CAPTIONS.find(function (caption) {
      return src.indexOf(caption.srcMatch) !== -1 ||
        (Number.isFinite(duration) && duration >= caption.minDuration && duration <= caption.maxDuration);
    });
  }

  function setCaptions(video, enabled) {
    Array.prototype.forEach.call(video.textTracks || [], function (track) {
      if (track.kind === 'captions' || track.kind === 'subtitles') {
        track.mode = enabled ? 'showing' : 'disabled';
      }
    });
  }

  function captionsAreEnabled(video) {
    var parent = video && video.parentElement;
    var button = parent && parent.querySelector(
      '.bison-product-video-controls [data-bison-caption-control]'
    );
    return !!button && button.getAttribute('aria-pressed') === 'true';
  }

  function enhance(video) {
    if (video.dataset.bisonProductVideoEnhanced === 'true') return;
    if (video.closest('.bison-video-controls')) return;

    video.dataset.bisonProductVideoEnhanced = 'true';
    video.muted = true;
    video.defaultMuted = true;

    var parent = video.parentElement;
    if (!parent) return;
    parent.classList.add('bison-product-video-host');

    var controls = document.createElement('div');
    controls.className = 'bison-product-video-controls';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', 'Video sound and caption controls');

    var sound = document.createElement('button');
    sound.type = 'button';
    sound.className = 'bison-product-video-control';
    sound.textContent = video.muted ? 'SOUND' : 'MUTE';
    sound.setAttribute('aria-label', 'Turn sound on');
    sound.setAttribute('aria-pressed', 'false');

    sound.addEventListener('click', function (event) {
      event.stopPropagation();
      video.muted = !video.muted;
      sound.textContent = video.muted ? 'SOUND' : 'MUTE';
      sound.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
      sound.setAttribute('aria-pressed', String(!video.muted));
      if (video.paused) video.play().catch(function () {});
    });

    var captions = document.createElement('button');
    captions.type = 'button';
    captions.className = 'bison-product-video-control';
    captions.dataset.bisonCaptionControl = 'true';
    captions.textContent = 'CC';
    captions.setAttribute('aria-label', 'Turn captions on');
    captions.setAttribute('aria-pressed', 'false');

    captions.addEventListener('click', function (event) {
      event.stopPropagation();
      var enabled = captions.getAttribute('aria-pressed') !== 'true';
      setCaptions(video, enabled);
      captions.textContent = 'CC';
      captions.setAttribute('aria-label', enabled ? 'Turn captions off' : 'Turn captions on');
      captions.setAttribute('aria-pressed', String(enabled));
    });

    controls.appendChild(sound);
    controls.appendChild(captions);
    parent.appendChild(controls);

    function addCaptionTrack() {
      var match = captionFor(video);
      var existing = video.querySelector('track[kind="captions"], track[kind="subtitles"]');

      if (match && match.poster) {
        video.poster = match.poster;

        var slide = video.closest('.product-main-slide');
        var gallery = video.closest('[data-product-images]');
        var index = slide && slide.getAttribute('data-index');
        var thumbnail = gallery && index !== null
          ? gallery.querySelector('[data-product-thumb][data-index="' + index + '"]')
          : null;

        if (thumbnail) {
          Array.prototype.forEach.call(thumbnail.querySelectorAll('source'), function (source) {
            source.srcset = match.poster;
          });
          var thumbnailImage = thumbnail.querySelector('img');
          if (thumbnailImage) {
            thumbnailImage.src = match.poster;
            thumbnailImage.srcset = match.poster;
          }
        }
      }

      if (!existing && match) {
        existing = document.createElement('track');
        existing.kind = 'captions';
        existing.src = match.track;
        existing.srclang = 'en';
        existing.label = 'English';
        existing.default = true;
        video.appendChild(existing);
      }

      if (existing) {
        captions.hidden = false;
        window.setTimeout(function () { setCaptions(video, false); }, 0);
      } else {
        captions.hidden = true;
      }
    }

    // Source URLs identify the poster and captions before Safari loads metadata.
    addCaptionTrack();
    if (video.readyState < 1) {
      video.addEventListener('loadedmetadata', addCaptionTrack, { once: true });
    }

    video.addEventListener('playing', function () {
      var slide = video.closest('.product-main-slide');
      if (slide && video.classList.contains('product-video-mp4-sound')) {
        slide.classList.remove('bison-mobile-video-pending');
      }
    });

    video.addEventListener('volumechange', function () {
      sound.textContent = video.muted ? 'SOUND' : 'MUTE';
      sound.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
      sound.setAttribute('aria-pressed', String(!video.muted));
    });
  }

  var landscapePlacement = null;

  function isMobileDevice() {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches ||
      window.matchMedia('(max-width: 768px)').matches;
  }

  function mobileVideoForSlide(slide) {
    return slide && slide.querySelector('.medium-up--hide .product-video-mp4-sound');
  }

  function stopOtherMobileVideos(activeVideo) {
    var activeSlide = activeVideo && activeVideo.closest('.product-main-slide');
    Array.prototype.forEach.call(
      document.querySelectorAll('.template-product [data-product-images] video'),
      function (video) {
        if (video === activeVideo) return;
        video.pause();
        video.currentTime = 0;
        if (video.classList.contains('product-video-mp4-sound')) {
          video.classList.add('hide');
        }
        var otherSlide = video.closest('.product-main-slide');
        // Shopify includes desktop and mobile video elements in the same slide.
        // Stopping the desktop sibling must not deactivate the playing slide.
        if (otherSlide && otherSlide !== activeSlide) {
          otherSlide.classList.remove('bison-mobile-inline-active');
          otherSlide.classList.remove('bison-mobile-video-pending');
        }
      }
    );
    if (activeSlide) {
      activeSlide.classList.add('bison-mobile-inline-active');
    } else {
      document.documentElement.classList.remove('bison-video-rotation-active');
    }
  }

  function playMobileInline(slide, autoplay) {
    var video = mobileVideoForSlide(slide);
    if (!video) {
      stopOtherMobileVideos(null);
      return false;
    }

    // Keep the real image visible until the playing event confirms playback.
    // A video poster alone can disappear when Safari rejects a play request.
    if (video.paused || video.readyState < 3) {
      slide.classList.add('bison-mobile-video-pending');
    }

    // iOS may choose Shopify's HLS source first; its audio can continue while
    // the inline video layer freezes after rotation. Use the supplied MP4 for
    // the mobile inline player so the same rendered frames survive reflow.
    if (video.dataset.bisonMobileMp4 !== 'true') {
      var mp4Source = video.querySelector('source[type="video/mp4"]');
      if (mp4Source) {
        video.src = mp4Source.getAttribute('src');
        video.dataset.bisonMobileMp4 = 'true';
        video.load();
      }
    }

    stopOtherMobileVideos(video);
    slide.classList.add('bison-mobile-inline-active');
    video.classList.remove('hide');
    // Swipe selection can run outside Safari's sound-enabled user gesture.
    // Muted autoplay starts reliably; the SOUND button can enable audio.
    video.muted = !!autoplay;
    video.defaultMuted = !!autoplay;
    video.playsInline = true;
    video.controls = false;
    if (autoplay) video.setAttribute('muted', '');
    else video.removeAttribute('muted');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.removeAttribute('controls');
    video.preload = 'auto';

    function syncActiveCaptions() {
      var enabled = captionsAreEnabled(video);
      setCaptions(video, enabled);
      window.setTimeout(function () { setCaptions(video, enabled); }, 120);
    }

    syncActiveCaptions();
    video.addEventListener('playing', syncActiveCaptions, { once: true });
    video.addEventListener('loadeddata', syncActiveCaptions, { once: true });

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        video.addEventListener('canplay', function () {
          video.play().catch(function () {});
        }, { once: true });
        video.load();
      });
    }
    return true;
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selector = '.template-product [data-product-images] video, .template-product media-gallery video, .template-product .product__photos video';
    Array.prototype.forEach.call(scope.querySelectorAll(selector), enhance);
    if (root && root.matches && root.matches(selector)) enhance(root);
  }

  function init() {
    scan(document);

    document.addEventListener('bison:product-slide-change', function (event) {
      if (!isMobileDevice()) return;
      var slide = event.detail && event.detail.slide;
      if (slide) playMobileInline(slide, true);
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.closest) return;
      if (target.closest('.bison-product-video-controls, .bison-video-share, .bison-video-fullscreen, .bison-video-exit, .bison-video-end-card, .bison-video-share-menu')) return;

      var isMobile = isMobileDevice();
      var thumbnail = target.closest('[data-product-thumb]');
      if (isMobile && thumbnail) {
        var index = thumbnail.getAttribute('data-index');
        var productSection = thumbnail.closest('[data-section-id]');
        var selectedSlide = (productSection || document).querySelector(
          '[data-product-images] .product-main-slide[data-index="' + index + '"]'
        );
        if (playMobileInline(selectedSlide)) {
          window.setTimeout(function () { playMobileInline(selectedSlide); }, 0);
        } else {
          stopOtherMobileVideos(null);
        }
        // Do not cancel the click; the gallery still needs to select the slide.
        return;
      }

      if (!isMobile && thumbnail) {
        var desktopIndex = thumbnail.getAttribute('data-index');
        var desktopSection = thumbnail.closest('[data-section-id]');
        var desktopSlide = (desktopSection || document).querySelector(
          '[data-product-images] .product-main-slide[data-index="' + desktopIndex + '"]'
        );
        var desktopVideo = desktopSlide && desktopSlide.querySelector(
          '.product__video-wrapper.small--hide video, .small--hide video'
        );
        if (desktopVideo) {
          desktopVideo.muted = false;
          desktopVideo.defaultMuted = false;
          desktopVideo.removeAttribute('muted');
        }
      }

      // The modal trigger is retained as a non-mobile fallback only.
      if (target.closest('.product-video-trigger')) return;

      if (isMobile) {
        var poster = target.closest('.product-main-slide.is-selected .image-wrap.medium-up--hide');
        var slide = poster && poster.closest('.product-main-slide');
        if (slide && mobileVideoForSlide(slide)) {
          event.preventDefault();
          event.stopPropagation();
          playMobileInline(slide);
          return;
        }
      }

      // Shared players handle picture clicks once, independently of native controls.
      if (target.closest('video[data-bison-click-playback="true"]')) return;

      var fullScreenVideo = target.closest('video.bison-landscape-fullscreen');
      if (fullScreenVideo) {
        event.preventDefault();
        event.stopPropagation();
        if (fullScreenVideo.paused) fullScreenVideo.play().catch(function () {});
        else fullScreenVideo.pause();
        return;
      }

      var host = target.closest('.bison-product-video-host');
      if (!host) return;

      var video = host.querySelector('video');
      if (!video) return;

      event.preventDefault();
      event.stopPropagation();
      if (video.paused) video.play().catch(function () {});
      else video.pause();
    }, true);
    function cleanUpForViewport() {
      if (!isMobileDevice()) {
        stopOtherMobileVideos(null);
        return;
      }

      var selected = document.querySelector(
        '.template-product [data-product-images] .product-main-slide.bison-mobile-inline-active'
      );
      var activeVideo = mobileVideoForSlide(selected);
      stopOtherMobileVideos(activeVideo || null);
    }

    function syncLandscapeVideo() {
      var landscape = window.matchMedia('(orientation: landscape)').matches;
      // Once the video is in the landscape overlay it is no longer a child of
      // the Shopify gallery. Keep using that same element until portrait
      // returns instead of losing it on every Safari viewport resize.
      var activeSlide = landscapePlacement && landscape
        ? landscapePlacement.slide
        : document.querySelector(
            '.template-product [data-product-images] .product-main-slide.bison-mobile-inline-active'
          );
      var activeVideo = landscapePlacement && landscape
        ? landscapePlacement.video
        : mobileVideoForSlide(activeSlide);

      Array.prototype.forEach.call(
        document.querySelectorAll('.bison-landscape-fullscreen'),
        function (video) {
          if (video !== activeVideo || !landscape) {
            video.classList.remove('bison-landscape-fullscreen');
          }
        }
      );

      if (activeVideo && landscape) {
        document.documentElement.classList.add('bison-video-rotation-active');
        if (!landscapePlacement || landscapePlacement.video !== activeVideo) {
          var controls = activeVideo.nextElementSibling &&
            activeVideo.nextElementSibling.classList.contains('bison-product-video-controls')
              ? activeVideo.nextElementSibling
              : null;
          var overlay = document.createElement('div');
          overlay.className = 'bison-landscape-overlay';
          landscapePlacement = {
            video: activeVideo,
            controls: controls,
            overlay: overlay,
            slide: activeSlide,
            parent: activeVideo.parentNode,
            nextSibling: controls ? controls.nextSibling : activeVideo.nextSibling
          };
          document.body.appendChild(overlay);
          overlay.appendChild(activeVideo);
          if (controls) {
            controls.classList.add('bison-landscape-controls');
            overlay.appendChild(controls);
          }
        }
        activeVideo.classList.add('bison-landscape-fullscreen');
        activeVideo.style.setProperty('display', 'block', 'important');
        activeVideo.style.setProperty('position', 'relative', 'important');
        activeVideo.style.setProperty('inset', 'auto', 'important');
        activeVideo.style.setProperty('width', 'auto', 'important');
        activeVideo.style.setProperty('height', 'auto', 'important');
        activeVideo.style.setProperty('max-width', '100vw', 'important');
        activeVideo.style.setProperty('max-height', '100dvh', 'important');
        activeVideo.style.setProperty('aspect-ratio', '16 / 9', 'important');
        activeVideo.style.setProperty('object-fit', 'contain', 'important');
        activeVideo.style.setProperty('object-position', 'center', 'important');
        activeVideo.style.setProperty('transform', 'none', 'important');
        activeVideo.style.setProperty('-webkit-transform', 'none', 'important');
        activeVideo.style.setProperty('z-index', '1', 'important');
        activeVideo.style.setProperty('background', '#000', 'important');
        setCaptions(activeVideo, captionsAreEnabled(activeVideo));
        activeVideo.play().catch(function () {});
      } else if (landscapePlacement) {
        var placed = landscapePlacement;
        placed.video.classList.remove('bison-landscape-fullscreen');
        ['display', 'position', 'inset', 'width', 'height', 'max-width',
          'max-height', 'aspect-ratio', 'object-fit', 'object-position',
          'transform', '-webkit-transform', 'z-index', 'background'].forEach(function (property) {
          placed.video.style.removeProperty(property);
        });
        if (placed.controls) placed.controls.classList.remove('bison-landscape-controls');
        if (placed.parent && placed.parent.isConnected) {
          placed.parent.insertBefore(placed.video, placed.nextSibling);
          if (placed.controls) placed.parent.insertBefore(placed.controls, placed.nextSibling);
        }
        if (placed.overlay && placed.overlay.parentNode) {
          placed.overlay.parentNode.removeChild(placed.overlay);
        }
        if (placed.slide) {
          placed.slide.classList.add('bison-mobile-inline-active');
          placed.slide.classList.add('is-selected');
        }
        placed.video.classList.remove('hide');
        landscapePlacement = null;

        // Let the theme's normal orientation handler reposition the carousel.
        // Forcing a delayed Flickity resize here causes iOS to apply stale
        // landscape cell measurements after portrait has already rendered.
        window.requestAnimationFrame(function () {
          if (placed.slide) placed.slide.classList.add('bison-mobile-inline-active');
          placed.video.classList.remove('hide');
          placed.video.play().catch(function () {});
        });

      } else {
        cleanUpForViewport();
      }
    }

    var landscapeSyncTimer = null;
    function scheduleLandscapeSync(delay) {
      window.clearTimeout(landscapeSyncTimer);
      landscapeSyncTimer = window.setTimeout(syncLandscapeVideo, delay);
    }

    window.addEventListener('orientationchange', function () {
      scheduleLandscapeSync(250);
    });
    window.addEventListener('resize', function () {
      // Mobile Safari fires many resizes as its browser chrome settles.
      // Debouncing prevents competing layout passes from moving the player.
      scheduleLandscapeSync(180);
    });

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') scan(mutation.target);
        Array.prototype.forEach.call(mutation.addedNodes || [], scan);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
